import { categories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  'Shoes': 'https://readdy.ai/api/search-image?query=Pair%20of%20trendy%20white%20sneakers%20on%20light%20wooden%20floor%20minimal%20product%20photography%20natural%20daylight%20clean%20aesthetic%20soft%20shadows%20editorial%20style%20with%20warm%20neutral%20background&width=400&height=320&seq=cat-img-shoes-v2&orientation=landscape',
  'Hoodies / Sweaters': 'https://readdy.ai/api/search-image?query=Oversized%20beige%20hoodie%20folded%20neatly%20on%20light%20linen%20fabric%20minimal%20product%20photography%20soft%20natural%20lighting%20warm%20cozy%20aesthetic%20clean%20composition%20editorial%20fashion%20display&width=400&height=320&seq=cat-img-hoodies-v2&orientation=landscape',
  'T-Shirts': 'https://readdy.ai/api/search-image?query=Stack%20of%20folded%20cotton%20t-shirts%20in%20neutral%20earth%20tones%20on%20light%20concrete%20surface%20minimal%20product%20photography%20soft%20daylight%20clean%20composition%20editorial%20style&width=400&height=320&seq=cat-img-tshirts-v2&orientation=landscape',
  'Jackets': 'https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20draped%20over%20wooden%20chair%20minimal%20product%20photography%20natural%20window%20light%20clean%20aesthetic%20soft%20shadows%20editorial%20fashion%20display%20warm%20neutral%20tones&width=400&height=320&seq=cat-img-jackets-v2&orientation=landscape',
  'Pants / Shorts': 'https://readdy.ai/api/search-image?query=Folded%20beige%20cargo%20pants%20on%20light%20textured%20surface%20minimal%20product%20photography%20natural%20daylight%20clean%20composition%20soft%20shadows%20editorial%20streetwear%20aesthetic&width=400&height=320&seq=cat-img-pants-v2&orientation=landscape',
  'Headwear': 'https://readdy.ai/api/search-image?query=Trendy%20baseball%20cap%20and%20bucket%20hat%20on%20light%20surface%20minimal%20product%20photography%20natural%20daylight%20clean%20aesthetic%20soft%20shadows%20editorial%20accessories%20display&width=400&height=320&seq=cat-img-headwear-v2&orientation=landscape',
  'Sets': 'https://readdy.ai/api/search-image?query=Matching%20casual%20outfit%20set%20with%20top%20and%20pants%20on%20light%20surface%20minimal%20product%20photography%20natural%20lighting%20clean%20aesthetic%20soft%20shadows%20editorial%20fashion%20display&width=400&height=320&seq=cat-img-sets-v2&orientation=landscape',
  'Underwear / Underpants': 'https://readdy.ai/api/search-image?query=Neatly%20folded%20cotton%20underwear%20basics%20on%20light%20linen%20surface%20minimal%20product%20photography%20soft%20natural%20lighting%20clean%20aesthetic%20editorial%20style%20warm%20neutral%20tones&width=400&height=320&seq=cat-img-underwear-v2&orientation=landscape',
  'Jersey': 'https://readdy.ai/api/search-image?query=Sports%20jersey%20folded%20on%20light%20surface%20minimal%20product%20photography%20natural%20daylight%20clean%20aesthetic%20soft%20shadows%20editorial%20sportswear%20display%20with%20warm%20background&width=400&height=320&seq=cat-img-jersey-v2&orientation=landscape',
  'Accessories': 'https://readdy.ai/api/search-image?query=Elegant%20watch%20sunglasses%20and%20minimal%20jewelry%20on%20light%20marble%20surface%20product%20photography%20natural%20daylight%20clean%20aesthetic%20soft%20shadows%20editorial%20luxury%20accessories%20display&width=400&height=320&seq=cat-img-accessories-v2&orientation=landscape',
  'Bags': 'https://readdy.ai/api/search-image?query=Leather%20crossbody%20bag%20and%20canvas%20tote%20on%20light%20surface%20minimal%20product%20photography%20natural%20daylight%20clean%20aesthetic%20soft%20shadows%20editorial%20bag%20display%20warm%20neutral&width=400&height=320&seq=cat-img-bags-v2&orientation=landscape',
  'Belts': 'https://readdy.ai/api/search-image?query=Leather%20belt%20coiled%20elegantly%20on%20light%20surface%20minimal%20product%20photography%20natural%20daylight%20clean%20aesthetic%20soft%20shadows%20editorial%20accessories%20display%20warm%20tones&width=400&height=320&seq=cat-img-belts-v2&orientation=landscape',
  'Perfumes': 'https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottle%20on%20light%20marble%20surface%20minimal%20product%20photography%20natural%20daylight%20clean%20aesthetic%20soft%20shadows%20editorial%20fragrance%20display%20warm%20neutral%20background&width=400&height=320&seq=cat-img-perfumes-v2&orientation=landscape',
  'Other Stuff': 'https://readdy.ai/api/search-image?query=Various%20lifestyle%20accessories%20including%20phone%20case%20keychain%20and%20small%20gadgets%20on%20light%20surface%20minimal%20product%20photography%20natural%20daylight%20clean%20aesthetic%20soft%20shadows&width=400&height=320&seq=cat-img-other-v2&orientation=landscape',
};

const featuredCategories = [
  {
    name: 'Shoes',
    subtitle: 'Nike, Jordan, Adidas & more',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20pairs%20of%20designer%20sneakers%20in%20various%20colors%20arranged%20on%20light%20wooden%20floor%20minimal%20product%20photography%20soft%20natural%20lighting%20editorial%20footwear%20collection%20display%20with%20warm%20neutral%20aesthetic&width=800&height=600&seq=feat-shoes-v2&orientation=landscape',
    style: 'dark',
  },
  {
    name: 'Hoodies & Sweaters',
    subtitle: 'Essentials, Stussy, Corteiz',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodie%20in%20warm%20taupe%20color%20laid%20flat%20on%20light%20textured%20surface%20minimal%20product%20photography%20soft%20natural%20lighting%20editorial%20streetwear%20aesthetic%20clean%20composition&width=800&height=600&seq=feat-hoodies-v2&orientation=landscape',
    style: 'image',
  },
  {
    name: 'Bags & Accessories',
    subtitle: 'Luxury and casual styles',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20handbag%20with%20gold%20accessories%20and%20silk%20scarf%20on%20light%20marble%20surface%20minimal%20product%20photography%20soft%20natural%20lighting%20editorial%20luxury%20aesthetic%20clean%20sophisticated%20composition&width=800&height=600&seq=feat-bags-v2&orientation=landscape',
    style: 'light',
  },
];

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12">
          <div>
            <p className="text-xs md:text-sm text-foreground-400 font-semibold uppercase tracking-widest mb-3">ALLCHINABUY</p>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-medium">
              Best Categories
            </h2>
          </div>
          <p className="text-foreground-500 text-sm md:text-base max-w-md mt-4 md:mt-0 leading-relaxed">
            Browse our organized spreadsheet categories to find exactly what you need. Every category is curated with trusted seller links.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {featuredCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-transform duration-300 hover:-translate-y-1 ${
                cat.style === 'dark' ? 'bg-foreground-900' : cat.style === 'image' ? 'bg-background-200' : 'bg-white border border-background-200/70'
              }`}
              style={{ minHeight: '340px' }}
            >
              {cat.style === 'dark' ? (
                <div className="p-8 flex flex-col justify-between h-full">
                  <div className="w-12 h-12 rounded-full bg-foreground-700 flex items-center justify-center mb-6">
                    <span className="text-white font-heading text-xl font-bold">S</span>
                  </div>
                  <div>
                    <h3 className="text-white text-2xl md:text-3xl font-heading font-medium mb-2">{cat.name}</h3>
                    <p className="text-foreground-300 text-sm">{cat.subtitle}</p>
                  </div>
                </div>
              ) : cat.style === 'image' ? (
                <>
                  <img src={cat.image} alt={cat.name} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <div className="absolute top-5 left-5">
                    <span className="inline-block px-3 py-1 bg-black/40 backdrop-blur-sm rounded-full text-white text-xs font-medium whitespace-nowrap">
                      {cat.name}
                    </span>
                  </div>
                  <div className="absolute bottom-6 left-6">
                    <h3 className="text-white text-2xl font-heading font-medium">{cat.name}</h3>
                  </div>
                </>
              ) : (
                <div className="p-8 flex flex-col h-full">
                  <h3 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mb-2">{cat.name}</h3>
                  <p className="text-foreground-500 text-sm mb-6">{cat.subtitle}</p>
                  <div className="mt-auto">
                    <img src={cat.image} alt={cat.name} className="w-full h-40 object-cover rounded-xl" loading="lazy" />
                  </div>
                </div>
              )}
            </a>
          ))}
        </div>

        <h3 className="font-heading text-2xl text-foreground-900 font-medium mb-6 text-center">
          All 14 Product Categories
        </h3>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 hover:shadow-md transition-all cursor-pointer"
            >
              <div className="h-28 overflow-hidden">
                <img
                  src={categoryImages[cat.name]}
                  alt={`${cat.name} - AllChinaBuy Spreadsheet category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3 flex items-center gap-2">
                <div className="w-5 h-5 rounded-md bg-primary-50 flex items-center justify-center flex-shrink-0">
                  <i className={`${cat.icon} text-primary-500 text-xs`}></i>
                </div>
                <span className="text-xs font-semibold text-foreground-700 whitespace-nowrap group-hover:text-primary-600 transition-colors truncate">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}